export default {
    isEditGroupDialogOpen: false,
    isEditOptionDialogOpen: false,
    editGroupItem: {},
    editOptionItem: {},
    workerAllocatedCancelPenaltyGroupList: [],
    workerAllocatedCancelPenaltyGroupOptionList: [],
    selectedPenaltyGroup: {},
    isPenaltyGroupSelectDialogOpen: false,
};
